import http from '../helpers/http';
import { API, ROOT_URL, GRAPHQL_ENDPOINT } from '../config/config.constants';
import { v4 as uuidv4 } from 'uuid';
import { SAMPARKTOKEN } from '../config/config.tokens';
import useSignInUrl from '../hooks/useSignInUrl';

export function submitContactUsFormAPI (formValues) {
  return http
    .post(API.CONTACT_US_FORM.SUBMIT_CONTACT_US_EMAIL,
      {
        subject: formValues.issueSelect,
        message: formValues.issueDetails
      })
    .then((response) => {
      const data = response.data;
      if (data) {
        return data;
      } else {
        return { error: response };
      }
    })
    .catch((error) => {
      return { error };
    });
}

export function uploadImagesAPI (eventFormDataImages) {
  return http
    .post(API.IMAGE_UPLOAD, eventFormDataImages)
    .then((response) => {
      const data = response.data;
      if (data) {
        return data;
      } else {
        return { error: response };
      }
    }).catch((error) => {
      return { error };
    });
}

export async function uploadCampaignImageAPI(imageFile) {
  const id = uuidv4();
  const prefix = 'sambandh/campaigns';
  return await useSignInUrl(imageFile, id, prefix);
}

export function getMyUserAccountDataAPI () {
  return http
    .get(API.AUTHENTICATION.MY_USER_ACCOUNT)
    .then((response) => {
      const data = response.data;
      if (data) {
        return data;
      } else {
        return { error: response };
      }
    })
    .catch(error => {
      console.error(error)
      throw error
    })
}
